// Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState('');
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || ''); // User role state
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            const response = await axios.post('/api/login', {
                email: email,
                password: password
            });
    
            // Başarılı giriş sonrası token'ı localStorage'a kaydet
            localStorage.setItem('sessionToken', response.data.session_token);
            localStorage.setItem('isLoggedIn', 'true');
            localStorage.setItem('userRole', response.data.role);
    
            setIsLoggedIn(true);
            setUserRole(response.data.role);
            window.location.reload();
        } catch (error) {
            console.error('Hata:', error);
            // Hata mesajını göster
            if (error.response && error.response.data && error.response.data.error) {
                setErrors({ server: error.response.data.error });
            } else {
                setErrors({ server: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.' });
            }
        }
    };

    const handleLogout = () => {
        setIsLoggedIn(false);
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userRole'); // userRole'u localStorage'dan kaldır
        setUserRole(''); // userRole state'ini sıfırla
        navigate('/');
    }

    useEffect(() => {
        // localStorage'daki isLoggedIn ve userRole durumunu kontrol et ve güncelle
        setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
        setUserRole(localStorage.getItem('userRole') || '');
    }, []);

    // Sayfa yenilendiğinde kontrol edilsin
    useEffect(() => {
        if (isLoggedIn) {
            navigate('/');
        }
    }, [isLoggedIn, navigate]);

    return (
        <div className="login-page">
            {/* breadcrumb-section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p>Giriş Yap</p>
                                <h1>Login</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end breadcrumb section */}

            <div className="row login-row">
                <div className="col-md-6 offset-md-3">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="mb-3">
                            <label htmlFor="login-email" className="form-label">E-posta</label>
                            <input
                                type="email"
                                id="login-email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                required
                                autoComplete="email"
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                        </div>

                        <div className="mb-3 position-relative">
                            <label htmlFor="login-password" className="form-label">Şifre</label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="login-password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                required
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="end-0 top-50 translate-middle-y border-0 bg-transparent"
                                style={{ right: '10px', cursor: 'pointer' }}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </button>
                            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                        </div>

                        <div className="d-flex gap-3">
                            <button type="submit" className="btn btn-profile-login btn-lg">Giriş Yap</button>
                            <div style={{ marginLeft: '20px' }}>
                                <Link to="/register" className="btn btn-profile-register btn-lg">Kayıt Ol</Link>
                            </div>
                        </div>

                        {isLoggedIn && (
                            <div className="mb-3">
                                <button onClick={handleLogout} className="btn btn-profile-logout btn-lg">Çıkış Yap</button>
                            </div>
                        )}

                        {message && <div className="alert alert-success">{message}</div>}
                        {errors.server && <div className="alert alert-danger">{errors.server}</div>}
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
